import API from "../../Data/Domain/API";
import URL from "../../Data/Domain/URL";

export async function getRepositorySdgs(params) {
  return await new API(
    URL.setParams(URL.buildUrl("repositorySdgs"), params)
  ).get();
}
